import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, Analytics } from 'firebase/analytics';
import { environment } from '../environments/environment';

const app = initializeApp(environment.firebase);

const analyticsPromise: Promise<Analytics | null> = isSupported()
  .then(supported => (supported ? getAnalytics(app) : null))
  .catch(() => null);

export async function getAnalyticsInstance(): Promise<Analytics | null> {
  return analyticsPromise;
}
